import { render } from "./ChevronLeft.vue?vue&type=template&id=e493c1d4&scoped=true"
const script = {}

import "./ChevronLeft.vue?vue&type=style&index=0&id=e493c1d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e493c1d4"]])

export default __exports__